import React from 'react';
import "./Header.scss";
import { motion } from 'framer-motion';
import images from "../../assets/imageExport";
import AppWrap from "../../Wrapper/AppWrap";

const scaleVariants = {
    whileInView:{
        //scale:[0,1],
        x:[-250, 0],
        opacity: [0, 1],
        //rotate:[10, 0],
        transition:{
            duration: 1.5,
            //ease: 'easeInOut'
        }
    }
}

const Header = () => {
    return (
        <div className="app__header" >
            <motion.div className="app__header-info"
                whileInView={{x: [-100, 0], opacity:[0,1], /*rotate:[10, 0],*/ transition:{duration: 0.5}}}
                //transition={{duration: 0.5}}
            >   
                <div className="app__header-badge">
                    <div className="badge-cmp app__flex">
                        <span>👋</span>
                        <div style={{marginLeft: 20}}>
                            <p className="p-text">Hello I am</p>
                            <h1 className="head-text">Developer</h1>
                        </div>
                    </div>
                    <div className="tag-cmp app__flex">
                        <p className="p-text">React developer</p>
                        <p className="p-text">Django developer</p>
                    </div>
                </div>
            </motion.div>

            <motion.div className="app__header-img"
                whileInView={{x: [-150, 0], opacity:[0,1], /*rotate:0,*/ transition:{duration: 1}}}
                // transition={{
                //     duration: 1,
                //     //delayChildren: 0.5
                // }}
                // whileHover = {{scale: 1.1, rotate:-5 }}
                // whileTap = {{ scale: 0.9 }}
                animate={{
                    scale:[1, 1.05, 1, ],
                    rotate:[0,-2, 0, ]
                }}
                transition={{
                    ease: 'easeInOut',
                    duration: 4,
                    repeat: Infinity,
                    //repeatDelay: 1
                }}
            >
                <img src={images.shasa1} alt="profile"/>
                {/* <motion.img
                    whileInView={{scale:[0,1]}}
                    transition={{duration:1, ease: 'easeInOut'}}
                    src={images.circle}
                    alt="profile cirle"
                    className="overlay_circle"
                /> */}
            </motion.div>

            <motion.div className="app__header-circles"
                variants={scaleVariants} 
                whileInView={scaleVariants.whileInView}
                >
                    {[images.javascript, images.react,images.python].map((circle, index) =>(
                        <div className="app__flex circle-cmp" key={`circle-${index}`}>
                            <img src={circle} alt='circle'/>
                        </div>
                    ))}
            </motion.div>
        </div>
    )
}

export default AppWrap(Header,'home',)